/**
 * Where toasts sit: bottom-right, above the strip where action buttons live.
 *
 * `SheetActions` publishes its live height in `SHEET_ACTIONS_HEIGHT_VAR` on
 * `<html>` while a sheet is open, because a footer that wraps to two rows on a
 * narrow screen is taller than any fixed offset. With no sheet open the floor
 * (5.5rem) still clears the table's page buttons and the reschedule dialog's
 * bottom bar.
 */
export const SHEET_ACTIONS_HEIGHT_VAR = '--sheet-actions-height';

const ABOVE_ACTIONS = `max(5.5rem, calc(var(${SHEET_ACTIONS_HEIGHT_VAR}, 0px) + 1.25rem))`;

export const TOAST_OFFSET = { bottom: ABOVE_ACTIONS };
